/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MeisLikeAlbumResponse } from "./MeisLikeAlbumResponse";

export type MeisLikeAlbumResponseApiRespoonse = {
  data?: MeisLikeAlbumResponse;
  status?: MeisLikeAlbumResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MeisLikeAlbumResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
